<template>
  <div class="app-container">
    <!--工具栏-->
    <div class="head-container">
      <el-input
        v-model="query.value"
        clearable
        placeholder="输入别名搜索"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="toQuery"
      />
      <el-input
        v-model="query.name"
        clearable
        placeholder="输入名称搜索"
        style="width: 200px;"
        class="filter-item"
        @keyup.enter.native="toQuery"
      />
      <el-button
        class="filter-item"
        size="mini"
        type="success"
        icon="el-icon-search"
        @click="toQuery"
      >搜索</el-button>
    </div>
    <!--表单组件-->
    <!--表格渲染-->
    <el-table v-loading="loading" :data="data" size="small" style="width: 100%;">
      <el-table-column prop="num" label="序号" />
      <el-table-column prop="alias" label="别名" />
      <el-table-column prop="name" label="名称" />
      <el-table-column prop="contactMethod" label="练习方法" />
      <el-table-column prop="trainingPurpose" label="训练目的" />
      <el-table-column prop="feedbackNotice" label="反馈须知" />
      <el-table-column
        v-if="checkPermission(['ADMIN','SERIESTASKS_ALL','SERIESTASKS_EDIT','SERIESTASKS_DELETE'])"
        label="操作"
        width="150px"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleClick(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination
      :total="total"
      :current-page="page + 1"
      style="margin-top: 8px;"
      layout="total, prev, pager, next, sizes"
      @size-change="sizeChange"
      @current-change="pageChange"
    />
  </div>
</template>

<script>
import checkPermission from "@/utils/permission";
import initData from "@/mixins/initData";
import { del } from "@/api/seriesTasks";

import eForm from "./form";

export default {
  components: { eForm },
  mixins: [initData],
  data() {
    return {
      delLoading: false
    };
  },
  created() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    checkPermission,
    beforeInit() {
      this.url = "api/seriesTasks";
      const sort = "id,desc";
      this.params = { page: this.page, size: this.size, sort: sort };
      if (this.query.value) {
        this.params["alias"] = this.query.value;
      }
      if (this.query.name) {
        this.params["name"] = this.query.name;
      }
      return true;
    },
    handleClick(e) {
      console.log(e);
      console.log("e");
      this.$emit("selectXilie", e);
    }
  }
};
</script>

<style scoped>
</style>
